import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import WidgetHeader from '../../../UserWidgets/_partials/WidgetHeader/WidgetHeader';
import WidgetHeaderMobile from '../../../UserWidgets/_partials/WidgetHeaderMobile/WidgetHeaderMobile';
import EditGallectionButton from '../EditGallectionButton';
import SearchField from '../SearchField';
import GallectionViewSwitcher from '../GallectionViewSwitcher';
import { GallectionType } from '../../../../../types/gallection';
import { MobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks/useFlag';
import s from './FoldersHeader.scss';

export interface Props {
  gallectionType: GallectionType;
}

export const FoldersHeader: React.FC<Props> = ({ gallectionType }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const isRedesigned = useFlag('little_gallery_redesign');

  const isGallery = gallectionType === GallectionType.GALLERY;

  const header = t(
    isGallery
      ? 'pages.gallections.gallery.folders'
      : 'pages.gallections.collection.folders'
  );

  if (isMobile) {
    return <WidgetHeaderMobile header={header} />;
  }

  return (
    <WidgetHeader
      header={header}
      className={classnames(s['header'], isRedesigned && s['redesigned'])}
      extras={
        <div className={s['header-extras']}>
          <EditGallectionButton className={s['edit-button']} />
          <SearchField className={s['flex-grow-right']} />
          <GallectionViewSwitcher className={s['section-view-switch']} />
        </div>
      }
    />
  );
};
FoldersHeader.displayName = 'FoldersHeader';

export default FoldersHeader;
